import CriteriaVM from './criteria-vm';
import FieldVM from './field-vm';
import TemplatesVM from './templates-vm';
import ResourceVM from './resource-vm';

export default function (loadData, wizard) {
  var self = this;

  self.$el = $('#wizard-container');
  self.$errContainer = self.$el.find('.instructor-error-list');
  self.$resourceContainer = $('#js_resource_container');

  self.selectTemplate = ko.observable(false);
  self.coursework = ko.observable();
  self.newResource = ko.observable(false);
  self.stepCounter = 1;
  self.currentStep = ko.observable();

  self.lastStep = ko.computed(() => {
    if (self.coursework() && self.coursework().template()) {
      return (self.currentStep() == 'cww-form-builder');
    } else {
      return (self.currentStep() == 'cww-review');
    }
  });

  self.savedAt = ko.observable();
  self.saving = ko.observable();
  self.dummyBool = ko.observable(true); //used to force computed observable to update
  self.maxAllowableGrade = ko.observable(100);
  self.courseworks = ko.mapping.fromJSON($('#coursework_json').val());
  self.gradePostTypeData = self.courseworks.grade_post_type_data;
  self.grading_policies = ko.mapping.fromJSON($('#grading_policies_json').val());

  self.selectedGradingPolicy = ko.computed(function () {
    var name = '';
    if (self.coursework() && self.coursework().grading_policy_entry_id()) {
      var selected_policy = _.find(self.grading_policies(), function (gp) {
        return gp.id() == self.coursework().grading_policy_entry_id();
      });
      if (selected_policy)
        name = selected_policy.name();
    }
    return name;
  });

  self.gradePostingData = ko.computed(function () {
    var name = '';
    if (self.coursework() && self.coursework().grade_post_type_data()) {
      var selected_policy = _.find(self.gradePostTypeData, function (gp) {
        return gp.id() == self.coursework().grade_post_type();
      });
      if (selected_policy)
        name = selected_policy.name();
    }
    return name;
  });

  self.defaultNoticeOptions = {
    parentObject: '.instructor-edit--sidebar',
    method: 'append'
  };

  self.showQuestionSelection = ko.observable(false);
  self.isQuestionInHolder = ko.computed(function() {
    if (!self.coursework())
      return false;

    return ko.utils.arrayFirst(self.coursework().coursework_fields(), function(question) {
      if (!question.id() || question.in_holder()) {
        return true;
      }
    });
  });

  self.initStepUI = function(id) {
    self.currentStep(id);

    if (id == 'cww-assets') {
      self.initResourcesSortable();
      self.loadExistingResources();
    }
  };
  /*---------------------------------------------------GENERAL STEP-------------------------------------------------*/
  self.initGradeBreakdownChart = function() {
    self.coursework().weight.subscribeChanged(function(newValue, oldValue) {
      var max, used;
      var percentRegEx = /\d+(?:\.\d+)?%/g;

      var currentGrade = _.find(self.coursework().grade_breakdown(), function(grade) { return grade.type() == 'current'; });
      currentGrade.percent(newValue);
      currentGrade.title(currentGrade.title().replace(percentRegEx, currentGrade.percent.extend({ numberToPercentage: 2 })()));

      var unusedGrade = _.find(self.coursework().grade_breakdown(), function(grade) { return grade.type() == 'unused'; });
      used = _.reduce(self.coursework().grade_breakdown(), function(memo, value){ return memo + parseFloat(value.percent()); }, 0);
      unusedGrade.percent(Math.max(0, (100 - used)));
      unusedGrade.title(unusedGrade.title().replace(percentRegEx, unusedGrade.percent.extend({ numberToPercentage: 2 })()));

      var otherCW = _.filter(self.coursework().grade_breakdown(), function (g) { return g.type() == ''; });
      var otherCWTotal = _.reduce(otherCW, function(memo, value){ return memo + value.percent(); }, 0);
      max = Math.max(0, (100 - otherCWTotal));
      self.maxAllowableGrade(max);
    });
  };
  /*---------------------------------------------------FORM STEP----------------------------------------------------*/
  self.getFormTemplate = function(type, path) {
    var templateName = Kadenze.Util.snakeCase(type);
    var questionTemplate = JST[path + templateName];
    return (_.isFunction(questionTemplate) ? Kadenze.I18n.tt(questionTemplate(), 'en') : null);
  };

  self.getFormAuthoringTemplate = function(type) {
    return self.getFormTemplate(type, 'templates/dynamic_fields/authoring/');
  };

  self.getFormSubmissionTemplate = function(type) {
    return self.getFormTemplate(type, 'templates/dynamic_fields/submission/');
  };

  self.initQuestionBankUI = function(element, item) {
    var $questionBank = $('#cww-question-bank');
    if ($questionBank.children().length === self.coursework().coursework_fields().length) {
      $questionBank.sortable({
        handle:'.display-table__sort-handle',
        start: function(e, ui) {
          // creates a temporary attribute on the element with the old index
          ui.item.data('startindex', ui.item.index());
        },
        stop: function(e, ui) {
          var startIndex = parseInt(ui.item.data('startindex'), 10);
          var newIndex = ui.item.index();

          var item = self.coursework().coursework_fields()[startIndex];

          //remove item from the old position
          self.coursework().coursework_fields.remove(function(question) {
            return question.dom_id() === item.dom_id();
          });

          //ko rebinds the array so remove duplicate item from the DOM
          ui.item.remove();

          //insert item back into the list at the new position
          self.coursework().coursework_fields.splice(newIndex, 0, item);

          //update db
          self.sortCourseworkFields($questionBank);
        }
      });
    }
  };

  self.sortCourseworkFields = function($questionBank) {
    var self = this;
    var $container = self.$el;
    var url = self.coursework().template() ?
      Kadenze.Routes.sort_admin_coursework_template_coursework_field_templates_path(
        self.coursework().id()
      ) :
      Kadenze.Routes.sort_course_coursework_coursework_fields_path(
        self.coursework().course_id(),
        self.coursework().id()
      );

    $.ajax({
      url: url,
      type: 'POST',
      data: $questionBank.sortable('serialize'),
      beforeSend: function(xhr, settings) {
        self.saving(true);
        Kadenze.UIUtil.showLoadingIndicator($container);
      },
      success: () => {},
      error: function(xhr, textStatus, errorThrown) {
        $questionBank.sortable('cancel');
        Kadenze.UIUtil.showNotice($container, {status: 'error',message: 'An unexpected error occurred. Please try again later.'}, 3000);
      },
      complete: function(xhr, textStatus) {
        self.saving(false);
        Kadenze.UIUtil.hideLoadingIndicator($container);
      }
    });
  };

  self.addQuestion = function(type) {
    var editable = self.coursework().template() ? false : true;
    var vm = new FieldVM({_type: type, previewing: false, editing: true, editable: editable, in_holder: true}, self);

    self.coursework().coursework_fields.push(vm);
    self.showQuestionSelection(false);
  };

  self.addSectionBreak = function() {
    var vm = new FieldVM({_type: 'SectionBreakField', previewing: false, editing: true, editable: true, in_holder: true}, self);
    self.coursework().coursework_fields.push(vm);
    self.showQuestionSelection(false);
  };

  self.savedAtText = ko.computed(function() {
    self.dummyBool();
    if (self.saving()) {
      //return Kadenze.I18n.t('dict.saving');
    }
    else if (self.savedAt()) {
      return Kadenze.I18n.t('dict.last_saved_at') + ' ' + moment(self.savedAt()).fromNow();
    }
    else {
      return '';
    }
  });
  /*---------------------------------------------------ASSETS STEP--------------------------------------------------*/
  self.initResourcesSortable = function() {
    if (!self.coursework().id())
      return;
    var url = Kadenze.Routes.sort_course_coursework_resources_path(self.coursework().course_id(), self.coursework().id());
    var $el = self.$resourceContainer.find('.display-table.sortable .display-table__body');
    Kadenze.UIUtil.initSortable(url, $el, self.$resourceContainer, self.sort);
  };

  self.filterOutById = function(ids, items) {
    return _.filter(items, function(item) {
      return !_.contains(ids, item.id);
    });
  };

  self.addResource = function() {
    var courseworkData = ko.mapping.toJS(self.coursework().resource_template);
    var resource = new ResourceVM(
      _.extend(
        courseworkData,
        {
          editing: false,
          _destroy: false
        }
      ),
      self
    );

    self.newResource(resource);
    self.newResource().resource().updated_at(new Date());
  };

  self.loadExistingResources = function() {
    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.course_resources_path(self.coursework().course_id())
    });

    request.done(function(response) {
      // Filter out already attached existing resources so they're
      // not displayed in the 'available to attach' list
      var resources = self.filterOutById(
        self.coursework().resource_ids(),
        response.resources
      );

      // Dynamically added property to track what resources are selected,
      // the KO bindings need this
      _.each(resources, function(resource) {  resource.selected = false; });

      // So existing_resources are available from $parent in _resource_form_content.html.haml
      self.existing_resources = ko.observableArray(resources);
    });
  };

  // Searches through self.existing_resources, if any have been selected
  // merge with self.resource_ids to create any new associations
  self.attachExistingResources = function() {
    if(self.existing_resources && self.existing_resources().length) {
      var existingResourceIds = _.chain(self.existing_resources())
        .select(function(res) { return res.selected; })
        .map(function(res) { return res.id; })
        .value();

      self.coursework().resource_ids(
        _.union(
          self.coursework().resource_ids(),
          existingResourceIds
        )
      );
    }
  };
  /*---------------------------------------------------REVIEW STEP--------------------------------------------------*/
  self.getFriendlyCSV = function(array, conjunction) {
    var csv = _.compact(array).join(', ');
    var last_comma = csv.lastIndexOf(',');
    csv = csv.slice(0, last_comma) + csv.slice(last_comma).replace(',', (' ' + conjunction + ' '));
    return csv;
  };

  self.criteriaNamesByScope = function(scope) {
    return ko.computed(function () {
      var criteria = self.coursework() ? self.coursework().grading_criteria() : [];
      var predicate = function (criterion) {
        return (!criterion._destroy() && criterion.scope() == scope) ? criterion.name() : null;
      };
      return self.getFriendlyCSV(_.map(criteria, predicate), 'and');
    })();
  };

  self.associatedLectures = ko.computed(function() {
    var lectures = self.coursework() && self.coursework().lectures ? self.coursework().lectures() : [];
    var predicate = function (lecture) {
      return (_.indexOf(self.coursework().lecture_ids(), lecture.id()) > -1) ? lecture.title_with_type_and_number() : null;
    };
    return self.getFriendlyCSV(_.map(lectures, predicate), 'and');
  });
  /*------------------------------------------------GLOBAL STATE MANAGEMENT-------------------------------------------*/
  self.bindData = function(courseworkData, isAutoSave) {
    if (typeof courseworkData === "string")
      courseworkData = JSON.parse(courseworkData)

    if (isAutoSave) {
      self.saveWithoutInterruption(courseworkData)
    } else {
      self.initEntireVm(courseworkData)
    }

    if (self.client_errors)
      self.client_errors.showAllMessages(false);

    self.initGradeBreakdownChart();

    $(document).off('pjax:start').on('pjax:start', function (evt) {
      $('.notice').remove();
    });
  }

  self.initEntireVm = courseworkData => {
    //Bind the entire VM
    var mapping = {
      coursework_fields: {
        create: options => {
          return new FieldVM(
            _.extend(
              options.data,
              {
                editing: false,
                _destroy: false
              }
            ),
            self
          );
        }
      },

      resources: {
        create: options => {
          return new ResourceVM(
            _.extend(
              options.data,
              {
                editing: false,
                _destroy: false
              }
            ),
            self
          );
        }
      },

      forum_settings: {
        update: options => {
          var vm = ko.mapping.fromJS(options.data);

          vm.name.extend({notify: 'always'});

          vm.computed_name = ko.computed({
            read: function () {
              if (vm.name())
                return vm.name()

              const fallbackAppendix = options.parent.name() || '[Title]'
              return `${options.parent.number()}: ${fallbackAppendix}`
            },

            write: function (value) {
              vm.name(value);
            }
          }).extend({notify: 'always'});

          return vm;
        }
      }
    };

    self.coursework(ko.mapping.fromJS(courseworkData, mapping));

    //Hack to prevent select picker from validating on page load
    if (self.coursework().grading_policy_entry_id() == null)
      self.coursework().grading_policy_entry_id(undefined);

    self.coursework().grading_policy_entry_id.subscribe(function () {
      if (isNaN(parseInt(self.coursework().grading_policy_entry_id())))
        return;

      var url = Kadenze.Routes.grading_policy_breakdown_course_coursework_index_path(
        self.coursework().course_id(),
        {
          coursework_id: self.coursework().id(),
          grading_policy_entry_id: self.coursework().grading_policy_entry_id()
        }
      );

      var request = new Kadenze.AjaxRequest({
        type: 'GET',
        url: url,
        data: null,
        timeout: 60000
      });

      request.done(response => {
        var mapped_breakdown = ko.mapping.fromJS(response.breakdown);
        self.coursework().grade_breakdown(mapped_breakdown());
        self.coursework().weight.valueHasMutated();
      });

      request.fail(() => { //TODO
      });
    });

    // Set date strings (KADWEB-2448)
    self.coursework().start_date_string(self.coursework().start_date());
    self.coursework().end_date_string(self.coursework().end_date());
    self.coursework().due_date_string(self.coursework().due_date());
    self.coursework().visible_on_string(self.coursework().visible_on());

    if (Kadenze.Util.getParameterByName('option') == 'template') {
      self.selectTemplate(true);

      if (_.isEmpty(self.templateVM)) {
        //If template selection is enabled, make template_id a required field
        self.coursework().template_id.extend(
          {
            required: {
              message: 'Please select a template before proceeding.'
            }
          }
        );

        //Bind element to template selection VM
        self.templateVM = new TemplatesVM(self);

        ko.applyBindingsWithValidation(
          self.templateVM,
          $('#cww-template-selector')[0],
          Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
        );
      }
    }
  }

  self.saveWithoutInterruption = courseworkData => {
    //Only update the IDs to avoid interrupting the user
    var mapped_coursework = ko.mapping.fromJS(courseworkData);

    self.coursework().id(mapped_coursework.id());

    $.each(self.coursework().coursework_fields(), function(index, field) {
      var mapped_field = mapped_coursework.coursework_fields()[index];

      if (mapped_field) {
        // field.id has to be updated without notifying any subscribers to ensure
        // KO's afterRender doesn't pickup this change and re-bind the
        // entire UI of the tab which would cause the drop-zone state to be lost.
        field.id.sneakyUpdate(mapped_field.id());
        //Rest of these are self-explanatory
        if (!field.isSectionBreak()) {
          field.grading_criteria.id(mapped_field.grading_criteria.id());
          field.grading_criteria.coursework_field_id(mapped_field.grading_criteria.coursework_field_id());
        }
      }
    });
  }

  self.dateDisplay = function(observable) {
    // TODO: Fix date format throughout the application pipeline.
    // Right now it is one format on load and another when you save
    var res = Kadenze.Util.getMomentDateFromObservable(observable);

    if (res.isValid()) {
      return res.format(Kadenze.I18n.t('date.formats.js_default_time'));
    }
    return '';
  };

  self.validate = function(step_id, deep) {
    var errors = [];

    if (step_id == 'cww-template-selection') {
      self.client_errors = ko.validation.group(self.coursework().template_id, { deep: deep });
    } else {
      self.client_errors = ko.validation.group(self.coursework(), { deep: deep });
    }

    self.client_errors.showAllMessages();

    errors = self.client_errors();

    if (deep) {
      var isValid = function (item) {
        errors = errors.concat(item.validate());
      };
      if (step_id == 'cww-form-builder') {
        _.each(self.coursework() ? self.coursework().coursework_fields() : [], isValid);
      } else if (step_id == 'cww-assets') {
        _.each(self.coursework() ? self.coursework().resources() : [], isValid);
      }
    }
    return errors;
  };

  self.saveCoursework = function() {
    var save = function() {
      var $container = self.$el;

      var response = self.save($container);

      response.error(function (xhr) {
        new Kadenze.Notice.error(
          $.extend(
            {},
            self.defaultNoticeOptions,
            { message: xhr.responseJSON.errors }
          )
        );
      });
    };

    var valid = self.validate(true).length == 0;

    !valid ?
      Kadenze.UIUtil.confirmAction(
        Kadenze.I18n.t('form_builder.invalid_save_confirmation').supplant({
          form_type: self.coursework().presentation_name()
        }),
        save
      ) :
      save();
  };

  this.previewCoursework = () => {
    const $container = this.$el;
    const response = this.save($container);

    response.success(() => {
      // Can't use PJAX here as the layout needs to change between requests
      window.location.href = Kadenze.Routes.course_coursework_path(
        this.coursework().course_id(),
        this.coursework().slug(),
        {
          preview: true,
          exit_path: Kadenze.Routes.edit_course_coursework_path(
            this.coursework().course_id(),
            this.coursework().slug()
          )
        }
      );
    });

    response.error(xhr => {
      new Kadenze.Notice.error(
        $.extend(
          {},
          this.defaultNoticeOptions,
          { message: xhr.responseJSON.errors }
        )
      );
    });
  };

  self.publishCoursework = function(item, element) {
    var $container = self.$el;
    var method = 'PATCH';

    if (self.publishError)
      self.publishError.destroy();

    var response = self.save($container, true);

    response.success(function () {
      var url = self.coursework().template() ?
        Kadenze.Routes.publish_admin_coursework_template_path(
          self.coursework().id()
        ) :
        Kadenze.Routes.publish_course_coursework_path(
          self.coursework().course_id(),
          self.coursework().id()
        );

      Kadenze.UIUtil.makeRequest(
        url,
        method,
        null,
        $container,

        function() { //BeforeSave
          self.saving(true);
        },

        function(incomingData) { //Success
          self.savedAt(new Date());
          self.bindData(incomingData.coursework);

          new Kadenze.Notice.success(
            $.extend(
              {},
              self.defaultNoticeOptions,
              { message: Kadenze.I18n.t('dict.publish_success') }
            )
          );
        },

        function(xhr) { //Error
          const humanFriendlyMsg = xhr.responseJSON.errors.length > 1 ?
            'these errors' :
            'this error'

          self.publishError = new Kadenze.Notice.error(
            $.extend(
              {
                title: `Please address ${humanFriendlyMsg} before publishing:`,
                persistent: true
              },
              self.defaultNoticeOptions,
              { message: xhr.responseJSON.errors }
            )
          );
        },

        function() { //Complete
          self.saving(false);
          //Nothing
        }
      );
    });
    response.error(function (xhr, textStatus, errorThrown) {
      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
    });
  };

  self.unpublishCoursework = function(item, element) {
    var unpublish = function() {
      var $container = self.$el;
      var url = self.coursework().template() ?
        Kadenze.Routes.unpublish_admin_coursework_template_path(
          self.coursework().id()
        ) :
        Kadenze.Routes.unpublish_course_coursework_path(
          self.coursework().course_id(),
          self.coursework().id()
        );
      var method = 'PATCH';

      Kadenze.UIUtil.makeRequest(url, method, null, $container,
        function(xhr, settings) { //BeforeSave
          self.saving(true);
        },

        function(incomingData) { //Success
          self.savedAt(new Date());
          self.bindData(incomingData.coursework);

          new Kadenze.Notice.success($.extend({}, self.defaultNoticeOptions, { message: Kadenze.I18n.t('dict.unpublish_success') }));

        },
        function(xhr, textStatus, errorThrown) { //Error
          new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
        },
        function(xhr, textStatus) { //Complete
          self.saving(false);
          //Nothing
        });
    };

    var confirmAction = moment(self.coursework().start_date_string()).isBefore(moment()) || self.coursework().entries_count() > 0;
    confirmAction ? Kadenze.UIUtil.confirmAction(Kadenze.I18n.t('form_builder.unpublish_confirmation').supplant({form_type: self.coursework().presentation_name()}), unpublish) : unpublish();
  };

  self.deleteCoursework = function(item, element) {
    // send survey confirm and success messages if coursework type is Survey
    var copyFamily = (self.coursework().type() === 'Survey') ? 'surveys' : 'coursework';
    //first, confirm
    Kadenze.UIUtil.confirmAction(Kadenze.I18n.t(copyFamily + '.delete.confirm'), function() {
      var $container = self.$el;
      var redirectUrl;

      if (self.coursework().template())
        redirectUrl = Kadenze.Routes.admin_coursework_templates_path();
      else if (self.coursework().type().toLowerCase() == 'survey')
        redirectUrl = Kadenze.Routes.course_surveys_path(self.coursework().course_id());
      else
        redirectUrl = Kadenze.Routes.course_coursework_index_path(self.coursework().course_id());

      var method = 'DELETE';

      if(!self.coursework().id()) {
        Kadenze.Request.pjax({url: redirectUrl, container: '#main-pjax-container'});
        return;
      }

      var url = self.coursework().template() ?
        Kadenze.Routes.admin_coursework_template_path(self.coursework().id()) :
        Kadenze.Routes.course_coursework_path(self.coursework().course_id(), self.coursework().id());

      Kadenze.UIUtil.makeRequest(url, method, null, $container,
        function() { //BeforeSave
          self.saving(true);
        },

        function() { //Success
          new Kadenze.Notice.success(
            $.extend(
              { dismissible: false },
              self.defaultNoticeOptions,
              { message: Kadenze.I18n.t(copyFamily + '.delete.success') }
            )
          );

          Kadenze.Request.pjax({url: redirectUrl, container: '#main-pjax-container'});
        },

        function(xhr) { //Error
          new Kadenze.Notice.error(
            $.extend(
              {},
              self.defaultNoticeOptions,
              { message: xhr.responseJSON.errors }
            )
          );
        },

        function() { //Complete
          self.saving(false);
        });
    });
  };

  self.save = ($container, isAutoSave, isPreviewSave) => {
    self.saving(true);

    var url = self.coursework().template() ?
      Kadenze.Routes.admin_coursework_templates_path() :
      Kadenze.Routes.course_coursework_index_path(self.coursework().course_id());

    var method = 'POST';

    if (self.coursework().id()) {
      url = self.coursework().template() ?
        Kadenze.Routes.admin_coursework_template_path(self.coursework().id()) :
        Kadenze.Routes.course_coursework_path(
          self.coursework().course_id(),
          self.coursework().id()
        );

      method = 'PATCH';
    }

    //Prep attachment of existing / shared resources
    self.attachExistingResources();

    var mapping = {
      include: ['attachment_ids','coursework_fields'],
      ignore: ['resources', 'existing_resources']
    };

    var sendingData = {
      coursework: JSON.parse(ko.mapping.toJSON(self.coursework, mapping))
    };

    _.each(sendingData.coursework.coursework_fields, function(_item, _idx) {
      _item.field_definition_attributes = _item.field_definition;
      delete _item.field_definition;

      _item.grading_criteria_attributes = _item.grading_criteria;
      delete _item.grading_criteria;
    });

    sendingData.coursework.coursework_fields_attributes = sendingData.coursework.coursework_fields;
    delete sendingData.coursework.coursework_fields;

    if (!self.coursework().template()) {
      //Prep resources
      sendingData.coursework.resources_attributes = [];

      _.each(self.coursework().resources(), function(_item, _idx) {
        var resource = ko.mapping.toJS(_item.resource, {ignore: ['order']});
        resource['info'] = ko.mapping.toJS(ko.mapping.fromJS(_item.resource().info), {ignore: ['__ko_mapping__']}); //Ugh
        sendingData.coursework.resources_attributes.push(resource);
      });
    }

    //convert dates to utc
    _.each(['start_date_string','end_date_string','due_date_string','visible_on_string'], function (date_field) {
      if (!_.isEmpty(sendingData.coursework[date_field])) {
        sendingData.coursework[date_field] = Kadenze.Util.getMomentDateFromObservable(self.coursework()[date_field]).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
        delete sendingData.coursework[date_field.replace('_string','')];
      }
    });

    // Delay the text showing again, so it and a success notification don't
    // show at the same time.
    var onNoticeDismiss = function() {
      return setTimeout(function() { self.savedAt(new Date()); }, 1000);
    };

    var request = Kadenze.UIUtil.makeRequest(
      url,
      method,
      sendingData,
      $container,

      function() { //BeforeSave
        self.saving(true);
      },

      function(incomingData) { //Success
        self.bindData(incomingData.coursework, isAutoSave);

        if(isAutoSave) {
          self.savedAt(new Date());
        }

        Kadenze.UIUtil.hideErrors(self.$errContainer);

        if(!isAutoSave && !isPreviewSave) {
          // Show the saved related text once this notice fades out (KADWEB-2054)
          new Kadenze.Notice.success(
            $.extend(
              {},
              self.defaultNoticeOptions,
              {
                message: Kadenze.I18n.t('dict.save_success'),
                onDismiss: onNoticeDismiss
              }
            )
          );
        }
      },

      function() { //Error
        //Will be handled by caller
      },

      function() { //Complete
        self.saving(false);
        //Will be handled by caller
      });

    return request;
  };

  self.updateSavedTime = function() {
    self.dummyBool(!self.dummyBool());
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorFormCreationViewModel');

    self.templates = {};
    $.each(['FillInTheBlankField','WrittenResponseField','MultipleChoiceField','TrueFalseField','RatingField','MatrixField',
      'AnswerBuilderField','TimelineField','InteractiveTimelineField','ImageMatchingField','SectionBreakField','QuestionSelectionField'], function(index, name) {
      self.templates[name] = self.getFormAuthoringTemplate(name);
      self.templates[name + 'Preview'] = self.getFormSubmissionTemplate(name);
    });
    self.templates['Attachments'] = self.getFormSubmissionTemplate('Attachments');

    that.bindData(loadData);
    Kadenze.Timers.push(setInterval(self.updateSavedTime, 1000));
    setTimeout(function() { Kadenze.WebApp.initFormElements(self.$el); }, 500);

    // Autosave
    var interval = setInterval(function() {
      // if (that.course().updated_at() )
      console.log('interval triggered');
      var updated = that.savedAt();
      var diff = moment().diff(updated, 'minutes');
      // Make sure no other save, publish, delete actions are in progress
      if (diff > 5 && !self.saving()) {
        // Not passing any container, setting isAutoSave to true
        console.log('auto-saving...');
        self.save(null, true);
      }
    }, 60000);
    Kadenze.Timers.push(interval);
  }(this);
}
